// extracted by css-extract-rspack-plugin
export default {"markdownHeroContainer":"Readme-module__markdownHeroContainer__V4BkO","markdownHeroLogo":"Readme-module__markdownHeroLogo__IZUb2"};